import moment from 'moment';
import {keyToFilterField} from '../../../forecast-app/shared/components/filters/filter_util';

export const filtersToSearchQuery = (filters, addedFilters) => {
	const searchQuery = {
		filters: [],
	};
	addedFilters.forEach(filter => {
		searchQuery.filters.push({
			field: keyToFilterField(filter.key),
			value: filter.value,
		});
	});

	if (filters?.person) {
		for (const [key, value] of Object.entries(filters.person)) {
			const searchQueryFilter = searchQuery.filters.find(filter => filter.field === keyToFilterField(key));
			if (!searchQueryFilter) {
				searchQuery.filters.push({
					field: keyToFilterField(key),
					value,
				});
			}
		}
	}
	return searchQuery;
};

export const mapCompressedAggregatedResourceNumbers = (compressedAggregatedResourceNumbersArray, aggregates) => {
	return compressedAggregatedResourceNumbersArray.map(compressedAggregatedResourceNumbers => {
		const values = compressedAggregatedResourceNumbers.split(',');

		if (values.length - 2 !== aggregates.length) {
			throw new Error(
				`Mismatch between asked-for aggregated values and the values in the response. Aggregates asked for: ${aggregates.join(
					','
				)}. Values in response: ${values.slice(2).join(',')}`
			);
		}

		const aggregatedResourceNumbers = {
			startDate: moment(values[0], 'YYYY-MM-DD'),
			endDate: moment(values[1], 'YYYY-MM-DD'),
		};
		values.slice(2).forEach((value, index) => {
			const aggregate = aggregates[index];
			aggregatedResourceNumbers[aggregate] = +value;
		});

		return aggregatedResourceNumbers;
	});
};
